import styled from 'styled-components'
import { OPEN_HOUSE_BANNER_TEXT } from '@CSSVars/colors'

export const _OpenHouseBanner = styled.div.attrs({
  className: 'open_house_banner',
})`
  width: 100%;
  height: 24px;
  padding: 7px;
  color: ${OPEN_HOUSE_BANNER_TEXT};
  background: #E6F5F6;
  border-radius: 0 0 10px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  div {
    font-size: 10px;
    font-weight: 600;
    color: ${OPEN_HOUSE_BANNER_TEXT};
    display: flex;
    flex-direction: row;
    margin-left: 7px;
    width: 100%;
    justify-content: space-between;
  }
  span {
    color: ${OPEN_HOUSE_BANNER_TEXT};
    font-size: 10px;
    white-space: nowrap;
  }
  position: absolute;
  bottom: 0;
  border: 1px solid ${OPEN_HOUSE_BANNER_TEXT};
  svg {
    path{
      fill: ${OPEN_HOUSE_BANNER_TEXT};
    }

  }
  z-index: 9;
`
